import {Container} from "react-bootstrap";

export function NotFound() {
    return (
        <Container className="mt-5 pt-5 text-center">
            <Container><h2>Page Not Found</h2></Container>
        </Container>
    )
}